import { Component, Input, Output, EventEmitter, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Site } from './screens.types';

@Component({
  selector: 'app-site-detail-screen',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './site-detail-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./site-detail-screen.component.scss'],
})
export class SiteDetailScreenComponent {
  @Input({ required: true }) site!: Site;
  @Output() openCommPatient = new EventEmitter<void>();
  @Output() openCanal = new EventEmitter<void>();
  @Output() openModeDegrade = new EventEmitter<void>();
  @Output() openRenfort = new EventEmitter<void>();

  readonly actionSent = signal<string | null>(null);

  tensionKey(): string {
    return { critique: 'critique', moderee: 'tension', fluide: 'fluide', ferme: 'fluide' }[this.site.statut];
  }

  tensionLabel(): string {
    return { critique: 'Critique', moderee: 'En tension', fluide: 'Fluide', ferme: 'Fermé' }[this.site.statut];
  }

  sendAction(label: string) {
    this.actionSent.set(label);
    setTimeout(() => this.actionSent.set(null), 2500);
  }

  readonly actions = [
    { id: 'renfort', label: 'Demander renfort', icon: '🆘' },
    { id: 'canal',   label: 'Démarrer une conversation',   icon: '💬' },
    { id: 'degrade', label: 'Mode dégradé',      icon: '⚠️' },
    { id: 'patient', label: 'Comm. patient',     icon: '📢' },
  ];

  getTimelineSlots(): string[] {
    const now = new Date();
    const slots: string[] = [];
    for (let i = 5; i >= 0; i--) {
      const t = new Date(now.getTime() - i * 15 * 60000);
      const h = String(t.getHours()).padStart(2, '0');
      const m = String(Math.floor(t.getMinutes() / 15) * 15).padStart(2, '0');
      slots.push(`${h}:${m}`);
    }
    return slots;
  }

  tlColor(c: string): string {
    return ({ vert: '#10B981', orange: '#F59E0B', rouge: '#EF4444' } as Record<string, string>)[c] ?? '#10B981';
  }

  tensionSince(): string | null {
    const tl = this.site.timeline;
    const firstIdx = tl.findIndex(c => c !== 'vert');
    if (firstIdx === -1) return null;
    const minutes = (5 - firstIdx) * 15;
    const hasCritique = tl.slice(firstIdx).some(c => c === 'rouge');
    return `${hasCritique ? 'Dégradation critique' : 'Tension'} depuis ${minutes} min`;
  }
}